import type { TrackedNotification } from './notificationTrackingTypes';

export type DeadlineAlert = {
  id: string;
  name: string;
  deadlineDate: string;
  level: 'overdue' | 'soon';
  days: number;
};

export function parseISODate(s: string): Date | null {
  const d = new Date(s + 'T12:00:00');
  return Number.isNaN(d.getTime()) ? null : d;
}

export function buildDeadlineAlerts(
  institutions: TrackedNotification[],
  today = new Date()
): DeadlineAlert[] {
  const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  const soonDays = 14;
  const alerts: DeadlineAlert[] = [];

  for (const inst of institutions) {
    if (!inst.deadlineDate) continue;
    if (inst.status === 'completed') continue;
    const d = parseISODate(inst.deadlineDate);
    if (!d) continue;
    const t = d.getTime();
    const days = Math.round((t - t0) / (24 * 60 * 60 * 1000));
    if (days < 0) {
      alerts.push({ id: inst.id, name: inst.name, deadlineDate: inst.deadlineDate, level: 'overdue', days });
    } else if (days <= soonDays) {
      alerts.push({ id: inst.id, name: inst.name, deadlineDate: inst.deadlineDate, level: 'soon', days });
    }
  }

  alerts.sort((a, b) => a.days - b.days);
  return alerts;
}
